<template>
  <div class="page-layout-warp">
    <div class="layout-header">
      <header-com/>
    </div>
    <div class="layout-content">
      <div class="layout-left">
        <left-com/>
      </div>
      <div class="layout-main">
        <div class="layout-breadcrumb">
          <bread-com/>
        </div>
        <div class="layout-main-content">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, computed} from "vue";
import HeaderCom from './header'
import LeftCom from './left'
import BreadCom from './bread'

onMounted(() => {
})

</script>
<style lang="less" scoped></style>